function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "spo-path-1",
  points: "0.000280485051 0 22.8844251 0 22.8844251 25 0.000280485051 25"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "spo-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#spo-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.4213,20.9272 L5.9243,17.4242 C6.2543,17.0952 6.3253,16.5882 6.0983,16.1812 C4.6703,13.6382 4.9633,10.4762 6.8343,8.2392 C8.7683,9.9352 11.7113,9.7422 13.4073,7.8092 C14.1573,6.9532 14.5683,5.8532 14.5643,4.7152 C14.5563,4.5542 14.5393,4.3952 14.5143,4.2372 C18.3853,4.6562 21.1833,8.1352 20.7643,12.0062 C20.5903,13.6032 19.8763,15.0942 18.7393,16.2312 L17.2393,17.7342 C15.0113,19.9652 11.5703,20.4422 8.8183,18.9012 C8.4123,18.6752 7.9043,18.7462 7.5753,19.0752 L4.0723,22.5792 C3.6163,23.0342 2.8773,23.0342 2.4213,22.5792 C1.9653,22.1232 1.9653,21.3832 2.4213,20.9272 M9.8823,2.1152 C11.3183,2.1152 12.4833,3.2792 12.4833,4.7152 C12.4833,6.1512 11.3183,7.3162 9.8823,7.3162 C8.4453,7.3162 7.2813,6.1512 7.2813,4.7152 C7.2813,3.2792 8.4453,2.1152 9.8823,2.1152 M0.000280485051,21.7522 C0.0013,23.5452 1.4553,24.9982 3.2483,25.0002087 C4.1093,25.0022 4.9353,24.6592 5.5423,24.0482 L8.5143,21.0782 C9.6903,21.6052 10.9633,21.8782 12.2513,21.8792 C14.6753,21.8862 17.0003,20.9232 18.7093,19.2032 L20.2093,17.7022 C23.7753,14.1372 23.7763,8.3562 20.2113,4.7892 C18.5063,3.0842 16.1953,2.1222 13.7833,2.1152 C12.3653,-0.0478 9.4633,-0.6508 7.3013,0.7672 C5.4003,2.0142 4.6703,4.4482 5.5703,6.5352 C3.0673,9.2172 2.4193,13.1382 3.9243,16.4832 L0.9523,19.4582 C0.3403,20.0642 -0.0027,20.8902 0.000280485051,21.7522",
  fill: "#FEFEFE",
  mask: "url(#spo-mask-2)"
})));

var SvgSportsOffers = function SvgSportsOffers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSportsOffers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sports-offers.70a751a3.svg";
export { ForwardRef as ReactComponent };